import { defineEntity, lifecycle, custom } from './_helpers.js';

/** Only verbs that controllers emit — no unused deleted/bulk keys. */
export default defineEntity('assetGroupCriticalityEvaluation', {
    created: lifecycle(),
    updated: lifecycle(),
    surveyStarted: custom({ scope: 'state' }),
    surveySubmitted: custom({ scope: 'state' }),
    approved: custom({ scope: 'state' }),
    surveyRepeated: custom({ scope: 'state' }),
    restarted: custom({ scope: 'state' }),
}, { includeDefaultLifecycle: false });
